import mock from './blglobal.mock';

let blGlobalTmp = window.blGlobal;

if (!blGlobalTmp) {
  const jsGlobalDOM = document.querySelector('.js-global-variable');
  if (jsGlobalDOM) blGlobalTmp = JSON.parse(jsGlobalDOM.dataset.globalVariable);
  else blGlobalTmp = mock;
}

const blGlobal = blGlobalTmp;

Object.freeze(blGlobal);

export default blGlobal;
